<template>
    <div class="ssssss">
		<header>
			<h1>
				<router-link to="/mine">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">全部订单</p>
			</h1>
		</header>
		<div class="dd_buti">
			<button class="dd_but" id="dd_butzj">专辑列表</button><button class="dd_buta" id="dd_butlist">章节列表</button>
		</div>
		<!-- 订单 -->
		<!-- 1 -->
		<div class="dd_cntx1">
			<!--  -->
			<div class="dd_cntx" v-for="item in list1">
				<p class="dd_ddh">订单号:<span>{{item.or_sn}}</span></p>
				<div class="dd_cntxa" @click="dindan(item.book_id,item.or_is_album)">
					<img :src="item.b_pic" class="dd_cntxaimg">
					<p class="dd_cntxap" id="dd_cntxaf">{{item.b_bookname}}</p>
					<p class="dd_cntxap" id="dd_cntxafa">
						<v-icon name="clone" class="dd_cntxafax"></v-icon>
						{{item.b_partnum}}个章节
					</p>
					<p class="dd_cntxap" id="dd_cntxapl">￥{{item.b_price}}</p>
					<p class="dd_cntxap" id="dd_cntxapr">{{item.or_add_time}}</p>
				</div>
			</div>
			<!--  -->
		</div>
		
		<!-- 2 -->
		<div class="dd_cntx2">
			
			<div class="dd_cntx" v-for="items in list2">
				<p class="dd_ddh">订单号:<span>{{items.or_sn}}</span></p>
				<div class="dd_cntxa" @click="dindans(items.zj_id,items.book_id,items.or_is_album)">
					<img :src="items.b_pic" class="dd_cntxaimg">
					<p class="dd_cntxap" id="dd_cntxaf">{{items.bp_bookname}}</p>
					<p class="dd_cntxap" id="dd_cntxafa">
						<v-icon name="clone" class="dd_cntxafax"></v-icon>
						{{items.bp_title}}
					</p>
					<p class="dd_cntxap" id="dd_cntxapl">￥{{items.bp_price}}</p>
					<p class="dd_cntxap" id="dd_cntxapr">{{items.or_add_time}}</p>
				</div>
			</div>

		</div>
		
		<!-- 订单end -->
		<p class="dd_indexend">已显示全部</p>
    </div>
</template>
<script>
import appNav from "../common/appNav";
import { CURL } from "../../lib/url.js";
import $ from 'jquery';
export default {
	components: {
	  appNav
	},
	data() {
	  return {
	    params: '',
	    list1:[],
	    list2:[],
	  }
	},
	created(){
      var openid=localStorage.getItem("openid");
      this.openid = openid;
   },
	mounted(){
		$('#dd_butzj').click(function(){
			$('.dd_but').css('color','#00a8d9');
			$('.dd_buta').css('color','#000');
			$('.dd_cntx1').show();
			$('.dd_cntx2').hide();
		})
		$('#dd_butlist').click(function(){
			$('.dd_buta').css('color','#00a8d9');
			$('.dd_but').css('color','#000');
			$('.dd_cntx1').hide();
			$('.dd_cntx2').show();
		})
		this.getAjax();
	},
	methods:{
	// 章节
	dindans (id,zd,e) {
		if(e == 0){
//	      location.href = '/discover/discont/mmm/'+[id,zd];
	      this.$router.push({path:'/discover/discont/mmm/'+[id,zd]})
	      // volume-up 音频
	    }else if(e == 2){
//	      location.href = '/video/playm/'+[id,zd]
	      this.$router.push({path:'/video/playm/'+[id,zd]})
	      // tv 视频
	    }
	},
	// 专辑
	dindan (id,e) {
	   if(e == 1){
//	      location.href = '/discover/discont/'+id
	      this.$router.push({path:'/discover/discont/'+id})
	      // volume-up 音频
	   }else if(e == 3){
//	      location.href = '/video/disv/'+id
	      this.$router.push({path:'/video/disv/'+id})
	      // tv 视频
	    }
	},
    getAjax:function () {
     var successCallback =  (response) => {
        //console.log(response)
        if(response.status==200){
          this.list1 = response.data1
          this.list2 = response.data2
        }
      }
      var errorCallback =  (response) => {
          console.log('服务器请求出错了')
      }
      this.$http.get(CURL+'/user/user/order?openid='+this.openid,{
        data:{}
      }).then(successCallback,errorCallback);
    }
  }
}

</script>
<style lang="scss" scoped>
.ssssss{
	background-color: #FFFFFF;
}
/*end*/
.dd_cntx2{
	display: none;
}
.dd_indexend{
	width: 100%;
	float: left;
	margin-top: 50px;
	text-align: center;
	font-size: 15px;
	color: #777;
}
/*cont*/
.dd_cntxafax{
	width: 11px;
	height: 10px;
	color: #999;
}
#dd_cntxafa{
	font-size: 13px;
	margin: 5px 0 10px 0;
	padding-left: 10px;
	color: #777;
}
#dd_cntxaf{
	margin-top: 9px;
	font-size: 16px;
	padding-left: 10px;
}
#dd_cntxapr{
	width: 50%;
	text-align: right;
	font-size: 13px;
	padding-right: 10px;
}
#dd_cntxapl{
	width: 30%;
	font-size: 13px;
	color: #bad565;
	padding-left: 10px;
}
.dd_cntxap{
	width: 80%;
	float: left;
}
.dd_cntxaimg{
	margin: 5px 0 5px 5px;
	width: 16%;
	float: left;
	height: 85px;
}
.dd_ddh{
	height: 50px;
	line-height: 50px;
	padding-left: 15px;
	color: #777;
}
.dd_cntxa{
	width: 94%;
	background-color: #fafafa;
	float: left;
	margin-left: 3%;
	margin-right: 3%;
}
.dd_cntx{
	float: left;
	width: 100%;
}
/*but*/
.dd_but{
	width: 49.5%;
	border-right: #eee solid 1px;
	background-color: #FFFFFF;
	color: #00a8d9;
}
.dd_buta{
	width: 49.5%;
	background-color: #FFFFFF;
}
.dd_buti{
	background-color: #FFFFFF;
	float: left;
	width: 100%;
	height: 45px;
	line-height: 45px;
	border-bottom: #eee solid 2px;
}
/*head*/
header{
  height: .4rem;
  background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
  float: left;
  width: 100%;
  h1{
    margin-top: .2rem;
  }
}
.set_1{
	text-align: center;
    float: left;
    width: 88%;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
    line-height:0;
}
.set_2{
	float: left;
	margin-top: -7px;
	margin-left: 3%;
	width: 5%;
	color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/mine/dingdan.vue